module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfegroups_remoteEntry_mjs_5bd59934__;